import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
function hasTouchPoints() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
export default function useIsTouchScreenDevice() {
  var _useState = useState(hasTouchPoints()),
    _useState2 = _slicedToArray(_useState, 2),
    isTouchScreenDevice = _useState2[0],
    setIsTouchScreenDevice = _useState2[1];
  useEffect(function () {
    setIsTouchScreenDevice(hasTouchPoints());
  }, []);
  return {
    isTouchScreenDevice: isTouchScreenDevice
  };
}